import { FunctionComponent } from 'react'
import NavBar from '../components/NavBar/NavBar'
import Table from '../components/Main/Table/Table'

const Main: FunctionComponent = () => {
	return (
		<>
			<NavBar />
			<Table />
		</>
	)
}

export default Main
